export default __webpack_public_path__ + "static/WorkSans-Regular-e4549b3bc5f2511c9775bad6797b7122.woff";